import { createDateTimeColumn } from '@app/components/date/create-date-time-column';
import { LTime } from '@app/components/date/LTime';
import { createCustomIdColumn } from '@app/modules/audit/components/create-custom-id-column';
import { MrtTable } from '@mi-front/ui';
import { Chip } from '@mui/material';
import { useIntl } from 'react-intl';
import { LtxMatchesReportVerifiedItem } from '../../../station-reports.types';

export function VerifiedMatchesTable({ data }: { data: LtxMatchesReportVerifiedItem[] }) {
  const { $t } = useIntl();

  return (
    <MrtTable
      data={data}
      columns={[
        createDateTimeColumn<LtxMatchesReportVerifiedItem>($t, {
          id: 'match.datetime',
          accessor: (row) => row.match?.datetime,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        }),
        createCustomIdColumn<LtxMatchesReportVerifiedItem>($t, {
          id: 'match.customId',
          accessor: (row) => row.match?.customId,
          enableColumnFilter: true,
          filterFn: 'contains',
        }),
        {
          id: 'ltxEntry.name',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.verified.ltxName',
            defaultMessage: 'LTX Nombre',
          }),
          accessorFn: (row) => row.ltxEntry.name,
          enableSorting: true,
          enableColumnFilter: true,
          filterFn: 'contains',
        },
        {
          id: 'match.matchedSchedule',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.verified.matchedSchedule',
            defaultMessage: 'Schedule',
          }),
          accessorFn: (row) => {
            const match = row.match;
            return match?.matchedSchedule?.datetime || null;
          },
          Cell: ({ row }) => {
            const match = row.original.match;
            const matchedSchedule = match?.matchedSchedule;
            if (matchedSchedule?.datetime) {
              return (
                <Chip
                  label={<LTime value={matchedSchedule.datetime} />}
                  size="small"
                  color="success"
                />
              );
            }
            return (
              <Chip
                label={$t({
                  id: 'audit.reportsScreen.ltxMatches.noSchedule',
                  defaultMessage: 'Sin schedule',
                })}
                size="small"
                color="warning"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          size: 150,
        },
        {
          id: 'ltxEntry.datetime',
          header: $t({
            id: 'audit.reportsScreen.ltxMatches.verified.ltxEntryDatetime',
            defaultMessage: 'LTX Entry Time',
          }),
          accessorFn: (row) => (row.ltxEntry?.datetime ? new Date(row.ltxEntry.datetime) : null),
          Cell: ({ row }) => {
            if (!row.original.ltxEntry?.datetime) return null;
            return (
              <Chip
                label={<LTime value={row.original.ltxEntry.datetime} showSeconds />}
                size="small"
                color="info"
                variant="outlined"
              />
            );
          },
          enableSorting: true,
          enableColumnFilter: false,
          filterVariant: 'time-range',
          size: 150,
        },
      ]}
    />
  );
}
